import { render, staticRenderFns } from "./concAddress.vue?vue&type=template&id=279ed4b1&scoped=true&"
import script from "./concAddress.vue?vue&type=script&lang=js&"
export * from "./concAddress.vue?vue&type=script&lang=js&"
import style0 from "./concAddress.vue?vue&type=style&index=0&id=279ed4b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279ed4b1",
  null
  
)

export default component.exports